import React from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import Notification from '~/components/Notification';
import {CATEGORY_IDS, STYLE_IDS} from '~/constants/QuoteConstants';
import {Button, Link, Stack} from '@customink/pigment-react';

function getSorryMessage(categoryId, inkColors, dismiss) {
  switch (categoryId) {
    case CATEGORY_IDS.KOOZIES:
      return (
        <p className="ndx-cta1">
          This koozie can only handle {inkColors}. Switch to the{' '}
          <Link
            href={`#/productCatalog/?pathoverride=styles/${CATEGORY_IDS.KOOZIES}/${STYLE_IDS.FULL_COLOR_KOOZIE}`}
            onClick={dismiss}>
            Full-Color Photo Can Cooler
          </Link>{' '}
          for more colors.
        </p>
      );
    case CATEGORY_IDS.PERFORMANCE:
      return (
        <p className="ndx-cta1">
          Performance styles can only handle {inkColors} per side.
        </p>
      );
    default:
      return (
        <p className="ndx-cta1">
          Sorry, this product’s material can only have {inkColors} per side.
        </p>
      );
  }
}

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function TooManyColors(props) {
  const {dismiss, notification} = props;
  const {categoryId, colorLimit} = notification;
  const inkColors = `${colorLimit} ink ${pluralize('color', colorLimit)}`;
  return (
    <Notification {...props} title="Too much color">
      {getSorryMessage(categoryId, inkColors, dismiss)}
      <Stack className="notification-stack">
        <Button
          size="large"
          variant="secondary"
          className="notification-cta"
          onClick={dismiss}>
          Okay
        </Button>
        <p className="ndx-cta1">
          or{' '}
          <Link href="#/productCatalog" onClick={dismiss}>
            swap your product
          </Link>
          .
        </p>
      </Stack>
    </Notification>
  );
}

const propTypes = {
  dismiss: PropTypes.func,
  notification: PropTypes.shape({
    categoryId: PropTypes.number,
    colorLimit: PropTypes.number,
    styleId: PropTypes.string
  })
};

TooManyColors.propTypes = propTypes;

TooManyColors.displayName = 'TooManyColors';
